function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import SideBarLayout from '@/components/layouts/SideBarLayout';
import { DynamicWebRoutes, WebRoutes } from '@/utils/constants';
import Footer from '@/components/Footer';
import { Box, Icon } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagicWandSparkles } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useOutlet, useParams } from 'react-router';
import { SlugByAuthProvider } from '@/types/server';
import { getChannelByName } from '@/actions/ChannelActions';
import Arrow from '../icons/lord/Arrow';
import useIntlMemo from '@/hooks/useIntlMemo';
import Headphones from '../icons/lord/Headphones';
export var PublicChannelContext = /*#__PURE__*/ React.createContext({
    channel: null
});
function PublicChannelLayout(param) {
    var children = param.children;
    var outlet = useOutlet();
    var navigate = useNavigate();
    var _React_useState = _sliced_to_array(React.useState(null), 2), channel = _React_useState[0], setChannel = _React_useState[1];
    var _useParams = useParams(), provider = _useParams.provider, username = _useParams.username;
    var topNavItems = useIntlMemo(function(intl) {
        return [
            {
                name: intl.formatMessage({
                    id: "TY8Ho1",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Commands"
                        }
                    ]
                }),
                href: DynamicWebRoutes.PUBLIC_CHANNEL_COMMANDS(provider !== null && provider !== void 0 ? provider : '', username !== null && username !== void 0 ? username : ''),
                icon: function() {
                    return /*#__PURE__*/ _jsx(Icon, {
                        p: "2px",
                        size: "lg",
                        as: FontAwesomeIcon,
                        icon: faMagicWandSparkles
                    });
                }
            },
            {
                name: intl.formatMessage({
                    id: "3s3LJl",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Song Requests"
                        }
                    ]
                }),
                href: DynamicWebRoutes.PUBLIC_CHANNEL_SONG_REQUESTS(provider !== null && provider !== void 0 ? provider : '', username !== null && username !== void 0 ? username : ''),
                icon: Headphones
            }
        ];
    });
    var bottomNavItems = useIntlMemo(function(intl) {
        return [
            {
                name: intl.formatMessage({
                    id: "rB7bIZ",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "My Dashboard"
                        }
                    ]
                }),
                href: WebRoutes.DASHBOARD,
                icon: function(props) {
                    return /*#__PURE__*/ _jsx(Box, {
                        transform: "rotate(180deg)",
                        children: /*#__PURE__*/ _jsx(Arrow, _object_spread_props(_object_spread({}, props), {
                            trigger: "hover"
                        }))
                    });
                }
            }
        ];
    });
    React.useEffect(function() {
        if (provider == null || username == null) {
            navigate(WebRoutes.DASHBOARD);
            return;
        }
        var authProvider = SlugByAuthProvider[provider];
        if (authProvider == null) {
            navigate(WebRoutes.DASHBOARD);
            return;
        }
        getChannelByName(authProvider, username).then(function(channel) {
            return setChannel(channel);
        }).catch(function() {
            return navigate(WebRoutes.DASHBOARD);
        });
    }, [
        navigate,
        provider,
        username
    ]);
    if (children == null && outlet == null) {
        throw new Error('PublicChannelLayout requires children or an Outlet');
    }
    return /*#__PURE__*/ _jsxs(SideBarLayout, {
        topNavItems: topNavItems,
        bottomNavItems: bottomNavItems,
        children: [
            /*#__PURE__*/ _jsx(PublicChannelContext.Provider, {
                value: {
                    channel: channel
                },
                children: children !== null && children !== void 0 ? children : outlet
            }),
            /*#__PURE__*/ _jsx(Footer, {})
        ]
    });
}
export default PublicChannelLayout;
